<p>Are you sure you want to delete?</p>
<button style="background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #E8E8E8;border-radius: 8px;outline: none;color: #666666;width: 60px;margin-left: 70px;" 
(click)="deleteNotes()">Yes</button>
<button style="background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #E8E8E8;border-radius: 8px;outline: none;color: #666666;width: 60px;margin-left: 10px;" 
(click)="closePopup()">No</button>